export default [
  {
    header: 'Bulk Topups',
  },
  {
    title: 'Topups',
    route: 'bulk-topups',
    icon: 'MessageSquareIcon',
  },
  {
    title: 'Transactions',
    route: { name: 'transactions' },
    icon: 'AlignJustifyIcon',
  },
]
